<template>
    <div>
        <v-navigation-drawer
            id="core-navigation-drawer"
            class="main-nav-drawer"
            v-model="_drawer"
            :expand-on-hover="expandOnHover"
            :right="$vuetify.rtl"
            mobile-breakpoint="960"
            app
            width="230"
            v-bind="$attrs"
        >
            <div class="logo-container">
                <router-link to="/" class="logo">
                    <v-img
                        class="logo-image"
                        :src="
                            $vuetify.theme.dark
                                ? '/assets/img/logo_acrisure_darkmode.png'
                                : '/assets/img/logo_acrisure_lightmode.png'
                        "
                        max-width="180"
                        contain
                    />
                </router-link>
            </div>
            <div style="border-bottom: 2px solid #ff302f"></div>

            <template v-if="userCreds.isDeveloper == 'True' || userCreds.isOperator == 'True'">
                <v-list dense expand nav>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="text-h4 ml-2"> Operator Access </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <template v-for="(operator, index) in operatorLinks">
                        <v-list-item link :to="operator.to" :key="index">
                            <v-list-item-icon>
                                <v-icon>{{ operator.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ operator.title }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-list>
                <v-divider class="my-2" />
            </template>
            <v-list dense expand nav>
                <!-- Style cascading bug  -->
                <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
                <div />
                <template v-for="(item, i) in computedItems">
                    <item :key="`item-${i}`" :item="item" />
                </template>

                <v-divider class="my-2" />
                <v-list-item
                    to="/addons"
                    :class="`nav-link ${!$vuetify.theme.dark ? 'black' : 'white'}--text`"
                    :active-class="`grey ${!$vuetify.theme.dark ? 'lighten-2 black' : 'darken-3 white'}--text`"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-package-variant-closed-plus</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Store</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Style cascading bug  -->
                <div />
            </v-list>
            <template v-if="userCreds.isDeveloper == 'True'">
                <v-divider class="my-2" />
                <v-list dense expand nav>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="text-h4 ml-2"> Developer Access </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <template v-for="(developerLink, index) in developerLinks">
                        <v-list-item link :to="developerLink.to" :key="index">
                            <v-list-item-icon>
                                <v-icon>{{ developerLink.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ developerLink.title }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-list>
                <v-divider class="my-2" />
            </template>

            <template v-slot:append>
                <v-list expand nav>
                    <v-list-item
                        :class="`nav-link ${!$vuetify.theme.dark ? 'black' : 'white'}--text`"
                        :active-class="`grey ${!$vuetify.theme.dark ? 'lighten-2 black' : 'darken-3 white'}--text`"
                        @click="handleSystemInformationDialog"
                    >
                        <v-list-item-icon>
                            <v-icon>mdi-information-outline</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>System</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </template>
        </v-navigation-drawer>
        <system-information-modal v-model="showSystemInfoModal" />
    </div>
</template>

<script>
// Utilities
import { mapGetters, mapMutations } from "vuex";
import Item from "@cmp/nav/Item.vue";
import SystemInformationModal from "@/components/modals/SystemInformationModal.vue";
import { TokenService } from "@/services";

export default {
    name: "DashboardCoreDrawer",

    props: ["drawer", "expandOnHover"],

    components: { Item, SystemInformationModal },

    data: () => ({
        items: [
            {
                icon: "mdi-view-dashboard",
                title: "dashboard",
                to: "/",
            },
            {
                icon: "mdi-account-group",
                title: "Users",
                to: "/users",
            },
            {
                icon: "mdi-cogs",
                title: "Company",
                to: "/company",
            },
            {
                icon: "mdi-message-text",
                title: "Messages",
                to: "/messages",
            },
            {
                icon: "mdi-file-document-edit-outline",
                title: "Forms",
                to: "/forms",
            },
            {
                icon: "mdi-clock-time-three-outline",
                title: "Timeclocks",
                to: "/timeclocks",
            },
            {
                icon: "mdi-camera",
                title: "Log-it",
                to: "/logit",
            },
            {
                icon: "mdi-calendar-check",
                title: "Planners",
                to: "/planners",
            },
            {
                icon: "mdi-file-document-multiple-outline",
                title: "Documents",
                to: "/documents",
            },
            {
                icon: "mdi-school-outline",
                title: "Training",
                to: "/training",
            },
            {
                icon: "mdi-cloud-upload-outline",
                title: "Assets",
                to: "/assets",
            },
            {
                icon: "mdi-credit-card-outline",
                title: "Billing",
                to: "/billing",
            },
            {
                icon: "mdi-file-chart",
                title: "Reports",
                to: "/reports",
            },
            {
                icon: "mdi-cast-audio-variant",
                title: "ranesCAST",
                newTab: true,
                href: window.appConfig?.VUE_APP_CAST_WEB_URL
                    ? window.appConfig?.VUE_APP_CAST_WEB_URL +
                      "auth?source=portal" +
                      `&token=${TokenService.getRefreshToken()}`
                    : undefined,
                disabled: !window.appConfig?.VUE_APP_CAST_WEB_URL,
                tooltip: !window.appConfig?.VUE_APP_CAST_WEB_URL ? "ranesCAST is temporarily unavailable" : undefined,
            },
            {
                icon: "mdi-monitor-cellphone",
                title: "User App",
                newTab: true,
                href: window.appConfig?.VUE_APP_APP_URL,
                disabled: !window.appConfig?.VUE_APP_APP_URL,
                tooltip: !window.appConfig?.VUE_APP_APP_URL ? "The User App is temporarily unavailable" : undefined,
            },
        ],
        operatorLinks: [
            {
                icon: "mdi-account-cog",
                title: "Companies",
                to: "/operator/companies",
            },
            {
                icon: "mdi-account-multiple",
                title: "Users",
                to: "/operator/users",
            },
            {
                icon: "mdi-bell-outline",
                title: "Updates",
                to: "/operator/updates",
            },
        ],
        developerLinks: [
            {
                icon: "mdi-key-alert",
                title: "Global Settings",
                to: "/developer/settings",
            },
        ],
        showSystemInfoModal: false,
    }),

    computed: {
        ...mapGetters("user", ["user"]),
        ...mapGetters("user", ["userCreds"]),
        ...mapGetters("heartbeat", ["internal"]),

        _drawer: {
            get() {
                return this.drawer;
            },
            set(val) {
                this.$emit("update:drawer", val);
            },
        },

        computedItems() {
            return this.internal ? this.items.map(this.mapItem) : this.items.map(this.mapItem);
        },

        profile() {
            return {
                avatar: true,
                title: this.$t("avatar"),
            };
        },
    },

    methods: {
        ...mapMutations("settings", ["toggleDarkMode"]),

        mapItem(item) {
            return {
                ...item,
                children: item.children ? item.children.map(this.mapItem) : undefined,
                title: this.$t(item.title),
            };
        },
        // Displaying the information dialog when click on the system icon
        handleSystemInformationDialog() {
            this.showSystemInfoModal = true;
        },
    },
};
</script>

<style scoped>
.main-nav-drawer {
    background: url("@assets/img/bg-main-nav-light.png");
    box-shadow: inset 0 0 0 1000px rgb(255 255 255 / 55%);
}
.main-nav-drawer .nav-link * {
    color: #222;
}

.theme--dark .main-nav-drawer {
    background: url("@assets/img/bg-main-nav-dark.png");
    box-shadow: inset 0 0 0 1000px rgb(0 0 0 / 10%);
}
.theme--dark .main-nav-drawer .nav-link * {
    color: #fff;
}

/* Logo container - fit better in small height views */
.logo-container {
    padding: 12px 8px 8px 8px;
    min-height: 60px;
    display: flex;
    align-items: center;
}

.logo-image {
    margin: 0 auto;
    max-width: 200px !important;
    width: 100%;
}

/* Custom scrollbar styling - less prominent for small height desktop views */
.main-nav-drawer ::v-deep .v-navigation-drawer__content {
    scrollbar-width: thin;
    scrollbar-color: rgba(155, 155, 155, 0.3) transparent;
}

.main-nav-drawer ::v-deep .v-navigation-drawer__content::-webkit-scrollbar {
    width: 6px;
}

.main-nav-drawer ::v-deep .v-navigation-drawer__content::-webkit-scrollbar-track {
    background: transparent;
}

.main-nav-drawer ::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb {
    background-color: rgba(155, 155, 155, 0.3);
    border-radius: 3px;
}

.main-nav-drawer ::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb:hover {
    background-color: rgba(155, 155, 155, 0.5);
}

.theme--dark .main-nav-drawer ::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb {
    background-color: rgba(200, 200, 200, 0.2);
}

.theme--dark .main-nav-drawer ::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb:hover {
    background-color: rgba(200, 200, 200, 0.4);
}
</style>
